






























import { Component, Vue, Model, Prop } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';

@Component({
  components: {},
})
export default class Login extends Vue {
  @Getter public loginError!: boolean;
  @Action('loginAction') public loginAction!: (payload: {email: string, password: string}) => void;
  private email: string;
  private password: string;

  constructor() {
    super();
    this.email = '';
    this.password = '';
  }

  public async onSubmit() {
    const isValid = await this.$validator.validate();
    if (isValid) {
      this.loginAction({email: this.email, password: this.password});
    }
  }
}
